<template>
  <el-dialog :title="form.id?'编辑':'新建'" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="主播身份" prop="userId">
        <el-select v-model="form.userId" :disabled="form.id" filterable remote placeholder="请输入手机号/姓名进行搜索" :remote-method="searchUsers" :loading="loading" @change="handleUserChange">
          <el-option v-for="item in usersOptions" :key="item.id" :label="item.realName + '('+ item.userPho+')' + item.position" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="昵称"  prop="liveName">
        <el-input v-model="form.liveName" placeholder="请输入昵称" />
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <el-switch v-model="form.state" :active-value="1" :inactive-value="0" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'
import ImageUpload from "@/components/ImageUpload";
function initFormBean() {
  const formBean = {
    id: null,
    liveName: null,
    userId: null,
    state: 1,
    position: null  // 添加 position 字段
  }
  return formBean
}

export default {
  components: { ImageUpload },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        liveName: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        userId: [{ required: true, message: '请选择主播身份', trigger: 'change' }],
      },
      isRepSub: false,
      usersOptions: [],
      loading: false,
      value: null,
    }
  },
  created() {
  },
  methods: {
    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          liveManageApi.searchUser({ keyword: query }).then(({data}) => {
            this.usersOptions = data;
          })
        }, 500);
      } else {
        this.usersOptions = [];
      }
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form.id = row.id
      this.form.liveName = row.liveName
      this.form.userId = row.userId
      this.form.state = row.state
      this.form.position = row.positionName
      this.usersOptions = [{id: row.userId, realName: row.realName, userPho: row.userPhone, position: row.positionName}]
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUserChange(userId) {
      if (userId) {
        const selectedUser = this.usersOptions.find(item => item.id === userId);
        if (selectedUser) {
          this.form.position = selectedUser.position;
          console.log('设置用户身份:', selectedUser.position);
        }
      } else {
        this.form.position = null;
        console.log('清空用户身份');
      }
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          // 验证position字段
          if (!this.form.position) {
            this.$message.error('该用户没有身份！')
            return
          }
          
          if (this.isRepSub) return
          this.isRepSub = true
          liveManageApi.createAnchor(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
